import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { COLOR_BUTTON, DOCUMENT_UPLOAD_ACCEPT } from '../../Config/Config';
import { validateDocumentFile } from '../../Validation';
import { Button, Text, Img, Icon, DatePicker } from '../../Atoms';
import { Upload, Input } from '../../Molecules';
import { OrganismSelectContact } from '../index';
import nature from '../../Json/Nature.json';
import fileImage from '../../assets/img/file.png';
import PropTypes from 'prop-types';

const MedicineStep1 = ({
                         benefItems,
                         medicine,
                         onChangeMedicine,
                         selectFile,
                         openNewMutual,
                         showNewMutual,
                         mutual,
                         onChangeMutual,
                         setShow,
                         medicineStep,
                         files,
                         selectedSeuil
                       }) => {
  // Check if form is valid to enable "Suivant" button
  const isFormValid = () => {
    // Check if required fields are filled
    const requiredFieldsValid =
      medicine.benefitaire &&
      medicine.date &&
      medicine.nature &&
      medicine.code &&
      medicine.amount;

    // Check if at least one file is uploaded
    const hasFiles = files && files.length > 0;

    // Check if a threshold has been selected
    const hasSelectedSeuil = selectedSeuil === 1 || selectedSeuil === 2;

    return requiredFieldsValid && hasFiles && hasSelectedSeuil;

  };
  return (
    <div>
      <Row className="row-document">
        <Col xs={6} className="col-document">
          <Text
            text="Bénéficiaire du soin"
            className="label-input-document"
          />

          <OrganismSelectContact
            containerClassName="select-document-container"
            placeholder=""
            iconClassName="icon-select-document"
            onChange={(e) => onChangeMedicine(e, 'benefitaire')}
            value={medicine.benefitaire}
            containerMobileOption="container-option-mobile-document"
            subTitleMobileClassName="sub-title-select-document"
            headerClassName="header-select-document"
            options={benefItems}
            iconSize={'7px'}
          />

        </Col>
        <Col xs={6} className="col-document">
          <Text text="Date du soin" className="label-input-document" />
          <DatePicker
            placeholder="JJ/MM/AAAA"
            renderIcon={false}
            containerClassName="full-container"
            className="full-container"
            onChange={(e) => onChangeMedicine(e, 'date')}
            selected={medicine.date}
          />
        </Col>
        <Col xs={6} lg={12} className="col-document">
          <Text
            text="Nature de la prestation"
            className="label-input-document"
          />
          <OrganismSelectContact
            containerClassName="select-document-container"
            placeholder=""
            iconClassName="icon-select-document"
            onChange={(e) => onChangeMedicine(e, 'nature')}
            value={medicine.nature}
            containerMobileOption="container-option-mobile-document"
            titleMobile="Choissisez la nature de votre prestation"
            subTitleMobileClassName="sub-title-select-document"
            subTitleMobile="Attention, si une des prestations ci-dessous est grisée cela veut dire que l’acte est non garanti dans votre contrat."
            header="Facture - Medecine douce"
            headerClassName="header-select-document"
            options={nature.data}
            iconSize={'7px'}
          />
        </Col>
        <Col xs={6} className="col-document">
          <div className="container-spaced">
            <Text
              text="Code Adeli ou N° Siret"
              className="label-input-document"
            />
            <Icon
              icon="info"
              size="14px"
              className="icon-info-document"
              onClick={() => setShow(true)}
            />
          </div>
          <Input
            type="number"
            placeholder=""
            classNameInputContainer="full-container"
            onChange={(e) =>
              onChangeMedicine(e.target.value, 'code')
            }
            value={medicine.code}
          />
        </Col>
        <Col xs={12} lg={6}>
          <div className="container-amount-document">
            <Text
              text="Montant dépensé :"
              className="label-input-document"
            />
            <Input
              value={medicine.amount}
              onChange={(e) =>
                onChangeMedicine(e.target.value, 'amount')
              }
              className="input-amount-doc"
              classNameContainer="container-input-amount-doc"
              placeholder=""
            />
            <Text text="€" className="label-input-document" />
          </div>
        </Col>
      </Row>
      <Upload
        handleFileChange={selectFile}
        accept={DOCUMENT_UPLOAD_ACCEPT}
        validateFile={validateDocumentFile}
        id="document"
        contentClassName={'input-file-document'}
        style={{ height: '1px' }}
        uploadContent={
          window.innerWidth > 768 ? (
            <div className="content-input-file-document">
              <Img src={fileImage} className="img-file-upload" />
              <div>
                Glissez et déposez vos fichiers ici, ou{' '}
                <span>téléchargez-les</span> depuis votre ordinateur
              </div>
            </div>
          ) : null
        }
      />
      {!showNewMutual && (
        <div className="container-btn-send-doc container-btn-send-doc-medicine ">
          <Button
            text="Ajouter une autre mutuelle"
            className="btn-send-doc btn-add-mutual"
            onClick={() => openNewMutual()}
            color={COLOR_BUTTON.SALMON}
          />
        </div>
      )}
      {showNewMutual && (
        <div>
          <div className="container-mutual-amount-document">
            <Text
              text="Montant remboursé par l’autre mutuelle :"
              className="label-input-document"
            />
            <Input
              value={mutual.amount}
              onChange={(e) =>
                onChangeMutual(e.target.value, 'amount')
              }
              className="input-amount-doc"
              classNameContainer="container-input-amount-doc"
              placeholder=""
            />
            <Text text="€" className="label-input-document" />
          </div>
          <Text
            text="Merci de bien vouloir nous transmettre le justificatif de votre autre mutuelle"
            className="label-input-document"
          />
          <Upload
            handleFileChange={(e) => onChangeMutual(e, 'file')}
            accept={DOCUMENT_UPLOAD_ACCEPT}
            validateFile={validateDocumentFile}
            id="mutual"
            contentClassName={'input-file-document'}
            style={{ height: '1px' }}
            uploadContent={
              window.innerWidth > 768 ? (
                <div className="content-input-file-document">
                  <Img src={fileImage} className="img-file-upload" />
                  <div>
                    Glissez et déposez vos fichiers ici, ou{' '}
                    <span>téléchargez-les</span> depuis votre ordinateur
                  </div>
                </div>
              ) : null
            }
          />
        </div>
      )}
      <div className="container-btn-send-doc container-btn-send-doc-medicine">
        <Button
          text="Suivant"
          className="btn-send-doc"
          onClick={() => medicineStep(2)}
          color={COLOR_BUTTON.SALMON}
          disabled={!isFormValid()}
          style={{ opacity: isFormValid() ? 1 : 0.5, cursor: isFormValid() ? 'pointer' : 'not-allowed' }}
        />
      </div>
    </div>
  );
};

MedicineStep1.propTypes = {
  benefItems: PropTypes.array.isRequired,
  medicine: PropTypes.shape({
    benefitaire: PropTypes.string,
    date: PropTypes.instanceOf(Date),
    nature: PropTypes.string,
    code: PropTypes.string,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  onChangeMedicine: PropTypes.func.isRequired,
  selectFile: PropTypes.func.isRequired,
  openNewMutual: PropTypes.func.isRequired,
  showNewMutual: PropTypes.bool.isRequired,
  mutual: PropTypes.shape({
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    file: PropTypes.any
  }).isRequired,
  onChangeMutual: PropTypes.func.isRequired,
  setShow: PropTypes.func.isRequired,
  medicineStep: PropTypes.func.isRequired,
  files: PropTypes.array.isRequired,
  selectedSeuil: PropTypes.number.isRequired
};

export default MedicineStep1;
